import { Component, OnInit } from '@angular/core';
import { CommercialDocumentService } from '../../../services/commercial-document.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from '../../../services/utilities.service';
import { CommercialDocument } from '../../../models/commercial-document';
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-commercial-documents',
  templateUrl: './commercial-documents.component.html',
  styleUrls: ['./commercial-documents.component.css']
})
export class CommercialDocumentsComponent implements OnInit {

  loading: boolean = false;
  commercialDocumentList: CommercialDocument[] = [];
  commercialDocumentTemp: CommercialDocument[] = [];
  dataFilter: string = null;
  commercialDocument: CommercialDocument = new CommercialDocument();
  page:number = 1;
  pagination: number = 20;

  constructor(private commercialDocumentService: CommercialDocumentService, private toast: ToastrManager, private utl: UtilitiesService, private modal: NgbModal) { }

  ngOnInit() {
    this.getDocuments();
  }

  getDocuments(){
    this.loading = true;
    this.commercialDocumentService.getDocuments().subscribe( response => {
      this.commercialDocumentList = response;
      this.commercialDocumentTemp = this.commercialDocumentList;
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toast.errorToastr(this.utl.formatMessages(error),'', {enableHTML: true});
    });
  }

  //Filtrar por id viaje y folio
  searchCommercialDocument(event){
    if(event.target.value)
    {
      this.dataFilter = String(event.target.value).trim();
      this.utl.search(this.commercialDocumentList, ['travel_id', 'document_number'], this.dataFilter, 'id', commercialDocumentList => this.commercialDocumentTemp = commercialDocumentList);
    }else{
      this.commercialDocumentTemp = this.commercialDocumentList;
    }
  }

  setModal(modal, _commercialDocument: CommercialDocument){
    this.commercialDocument = _commercialDocument;
    this.modal.open(modal, {size: 'lg'});
  }

  deleteDocument(){
    this.loading = true;
    this.commercialDocumentService.delete(this.commercialDocument).subscribe( response => {
      this.commercialDocumentList = response;
      this.commercialDocumentTemp = this.commercialDocumentList;
      this.loading = false;
      this.modal.dismissAll();
      this.toast.successToastr(this.setFormatCommercialDocumentType(this.commercialDocument.commercial_document_type_id) + ' ' + this.commercialDocument.commercialDocumentType.document + ' asociada al viaje ' + this.commercialDocument.travel_id + ' fue quitada correctamente', '', { enableHTML: true });
      this.setDefaultData();
    }, error => {
      this.loading = false;
      this.toast.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  update(message){
    this.toast.successToastr(message, '', { enableHTML: true });
    this.setDefaultData();
    this.getDocuments();
    this.modal.dismissAll();
  }

  setDefaultData(){
    this.dataFilter = null;
    this.commercialDocument = new CommercialDocument();
  }

  setFormatCommercialDocumentType(type: number): string{ return (type == 5) ? 'El' : 'La'; }
}
